import type { MemoryModule } from "@/modules";

async function documentAdvicePrompt(memoryModule: MemoryModule) {
	const prompt =
		(await memoryModule.getAgentMemory()?.getDocumentAdvicePrompt?.()) ||
		`당신은 매장 운영을 돕는 분석 어시스턴트입니다.
아래는 한 매장의 로그북(운영 메모와 매출/지표 데이터)입니다.
이 내용을 바탕으로 운영자에게 도움이 되는 조언을 한국어로 작성하세요.

작성 지침:
- 문단형 산문으로 작성하고, 마크다운 제목/불릿은 사용하지 마세요.
- 먼저 오늘 운영에 대한 간단한 인정/격려로 시작하세요.
- 다음 영업일 전망과, 데이터에 근거한 수치 기대치를 제시하세요.
- 입력에 없는 수치나 사실을 지어내지 마세요. 데이터가 없으면 일반적인 조언만 하세요.
- 실행 가능한 운영 팁을 1~2가지 제시하세요.
- 마지막은 짧은 응원의 한 문장으로 마무리하세요.
- 사용자가 입력한 언어로 답하세요.`;
	return prompt;
}

export default documentAdvicePrompt;
